<script setup>
import Card from '@/Components/Card/Card.vue';
import CardLabel from '@/Components/Card/CardLabel.vue';

defineProps({
  headers: Array
});
</script>
<template>
  <div id="raw-headers">
    <CardLabel
      :label="$t('header_analysis.partials.all_headers.raw_headers')"
    />
    <Card>
      <div class="flex flex-col">
        <div class="hidden grid-cols-8 gap-6 md:grid">
          <div class="col-span-2 font-bold text-nowrap">
            {{ $t('header_analysis.partials.all_headers.header') }}
          </div>
          <div class="col-span-6 font-bold text-pretty">
            {{ $t('header_analysis.partials.all_headers.value') }}
          </div>
        </div>
        <div
          v-for="(header, index) in headers"
          :key="index"
          class="grid grid-cols-1 gap-6 rounded-sm p-2 md:grid-cols-8"
          :class="{ 'bg-white-500!': index % 2 === 0 }"
        >
          <div class="col-span-2 font-bold break-words md:font-medium">
            {{ header.name }}
          </div>
          <div class="col-span-6 break-words">{{ header.value }}</div>
        </div>
      </div>
    </Card>
  </div>
</template>
